import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface RevokeUserDiscountResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function revokeUserDiscountAction(
  userId: string,
  discountId: string | number,
  discountUserId: string | number
): Promise<ApiResponse<RevokeUserDiscountResponse>> {
  return api.post<ApiResponse<RevokeUserDiscountResponse>>(
    `discounts/users/${userId}/revoke/${discountId}/${discountUserId}`
  )
}
